
    const config = {
      api_url: 'https://ccc.wangwanglive.com/apinew/',
      // api_url: 'https://ccc.wangwanglive.com/front/',
      login_url: 'https://www.flw.ph/plugin.php?id=zimu_fenlei&model=apiloginccc',
      login_mag_url: 'https://w.feilongwang.net/plugin.php?id=zimu_fenlei&model=apiloginccc',
      SOURCE: 1, // 默认来源标识，1为默认，2为h5.qqloon.com，3为h5.feilongvip.com
    };

    export default config;



// WEBPACK FOOTER //
// ./src/config/index.js